import React from 'react'
import './testimonials.css'
import {Swiper, SwiperSlide} from 'swiper/react'
import profile2 from "../../img/IMG_3017.JPG"
import avatar_3 from "../../img/avatar-3.svg"
import  avatar_5 from "../../img/avatar-svgrepo-com (2).svg"
import profile_1 from "../../img/profile1.jpg"
import { Pagination } from "swiper/modules"
import 'swiper/css/pagination'


const Testimonials = () => {
   const clients =[
        {
        img: profile2,
        review:
        "I was impressed with how quickly you delivered the project. Not only was the work completed ahead of schedule, but the quality was also outstanding. Their professionalism made the entire process smooth and enjoyable.",
        },
        {
            img: avatar_3,
            review:
            "I was blown away by the level of service provided by you. They went above and beyond to ensure that we were satisfied with every aspect of the project. Truly a top-notch experience!",
        },
        {
            img: avatar_5,
            review:
            "The collaboration with you was a game-changer for our business. Their insights and recommendations helped us improve our strategy significantly. I look forward to future projects together!",
            
        },
        {
            img: profile_1,
            review:
            "I was impressed with how quickly you delivered the project. Not only was the work completed ahead of schedule, but the quality was also outstanding. Their professionalism made the entire process smooth and enjoyable.",
           
        },

    ]

  return (
    <div>
      <div className="t-wrapper" id='Testimonials'>
        <div className="t-heading">
            <span>Client always get </span>
            <span>Exceptional Work </span>
            <span>from me.....</span>
            <div className="blur t-blur1" style={{ background: "var(--purple)"}}></div>
            <div className="blur t-blur2" style={{ background: "skyblue"}}></div>
        </div>
        <Swiper 
        
        modules={[Pagination]}
        slidesPerView={1}
        pagination={{clickable: true}}
        
        
        >
            {clients.map((client, index)=>{
                return(
                    <SwiperSlide key={index}>
                        <div className="testimonials" id='testimonial'>
                         <img src={client.img} alt="" />
                         <span>{client.review}</span>
                        </div>

                    </SwiperSlide>
                )

            })}



        </Swiper>


      </div>
    </div>
  )
}

export default Testimonials
